<template>
  <v-container fluid bg fill-height>
    <v-row justify="center" align="center">
      <v-col>
        <v-row justify="center" align="center">
          <v-img contain :src="logoimgPath" max-width="360"></v-img>
        </v-row>
        <v-row justify="center" align="center" class="pa-2">
          <div v-if="autherrflg">
            <span class="text-center amber--text text--lighten-3">
              <v-icon color="amber lighten-4" class="pa-2">warning</v-icon>{{errorMsg}}
            </span>
          </div>
        </v-row>
        <v-row justify="center" align="center" class="pa-4">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              outlined dark
              :rules="mainRules"
              v-model="usercd" color='indigo lighten-5'
              label="ユーザーID"
              prepend-icon="person"
              required
            ></v-text-field>
            <v-text-field
              outlined dark
              :rules="mainRules"
              v-model="pwd" color="indigo lighten-5"
              prepend-icon="mdi-lock"
              v-bind:type="showPassword ? 'text' : 'password'"
              v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="パスワード"
              @click:append="showPassword = !showPassword"
              required
              @keyup.enter="validate"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!valid" class="mb-5 grey--text text--lighten-5"
              block x-large color="indigo"
              @click="validate"
            >
              login
            </v-btn>
            <div>
              <span class="text-center indigo--text text--lighten-5">＊パスワードを忘れた場合は管理者にお問い合わせください</span>
            </div>
          </v-form>
        </v-row>
        <v-row class="pa-2">
          <v-spacer />
          <span class="text-center indigo--text text--lighten-3">
            ver.1.0.7
          </span>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import myAxios from '../../axios/myAxios.js'
import MsgList from '../modules/MsgList'
import axios from 'axios'

export default {
  data () {
    return {
      mainRules: [
        v => !!v || '入力は必須です'
      ],
      valid: true,
      logoimgPath: require('@/assets/img/MIoTASUsimple_wR.png'),
      mask: true,
      showPassword: false,
      usercd: '',
      pwd: '',
      ipadrs: '',
      usercdflg: false,
      pwdflg: false,
      inputerrflg: false,
      autherrflg: false,
      checkflg: false,
      errorMsg: '',
      connectionErrMsg: MsgList.MSG_CONNETION_ERROR
    }
  },
  created () {
    this.$store.dispatch('appSetting/fLogin')
    // IPアドレス取得
    axios.get('https://ipinfo.io/', {timeout: 10000}).then(res => {
      console.log(res.data.ip)
      this.ipadrs = res.data.ip
    }).catch(err => {
      console.log(err)
    })
  },
  methods: {
    validate () {
      this.$refs.form.validate()
      this.loginsubmit()
    },
    getHandlers () {
      return [...arguments].reduce((seed, item) => {
        const mergedHandlers = { ...item, ...seed }
        return mergedHandlers
      }, {})
    },
    // backendに情報を送り、レスポンスによって遷移先を変える
    loginsubmit: function () {
      // backendに送る前に改めて入力チェック
      this.usercdflg = true
      this.pwdflg = true
      this.checktext()

      // 入力チェック通過した場合、backendへ送る
      if (this.checkflg) {
        myAxios.post('api/login/login', {usr_cd: this.usercd, psswrd: this.pwd, ipadrs: this.ipadrs}).then(res => {
          const result = res.data.status
          const kiykSingleFlg = res.data.kiyk_single_flg
          const csrfToken = res.data.csrf_token
          const errorMsgFlg = res.data.errflg
          // 遷移先の変更
          // ログイン成功時
          if (result) {
            this.autherrflg = false
            // CSRFトークンをsessionStorageに保存
            sessionStorage.setItem('csrf_token', JSON.stringify(csrfToken))
            // ユーザに紐づく契約コードの数により遷移先を変更
            // 紐づく契約コードが単数の場合
            if (kiykSingleFlg) {
              this.$router.push('/initial')
              this.$store.dispatch('appSetting/tLogin')
            // 紐づく契約コードが複数の場合
            } else {
              this.$router.push('/kiykskSntk')
            }

          // ログイン失敗時
          } else {
            this.autherrflg = true
            this.pwd = ''
            this.mask = true
            // 表示するメッセージ
            if (errorMsgFlg === 2) {
              this.errorMsg = MsgList.MSG_E002_0005
            } else if (errorMsgFlg === 3) {
              this.errorMsg = MsgList.MSG_E002_0006
            } else {
              this.errorMsg = MsgList.MSG_E001_0001
            }
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          alert(this.connectionErrMsg)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        })
      }
    },
    // 入力値のチェック
    checktext: function () {
      // 再度入力が始まったとして、認証エラーを消す
      this.autherrflg = false

      // フォーカスされた かつ 内容が空文字・nullの場合、エラーメッセージを出す
      if ((this.usercdflg && !this.usercd) || (this.pwdflg && !this.pwd)) {
        this.inputerrflg = true
      } else {
        this.inputerrflg = false
      }

      // checkflgの設定
      if (this.usercd && this.pwd) {
        this.checkflg = true
      } else {
        this.checkflg = false
      }
    }
  },
  computed: {
    // スマホサイズかどうか調べる
    breakpoint () {
      var phoneFlg = false
      const breakpoint = this.$vuetify.breakpoint.name
      switch (breakpoint) {
        case 'xs':
          phoneFlg = true
          console.log(phoneFlg)
          break
        case 'sm':
          phoneFlg = true
          console.log(phoneFlg)
          break
        case 'md':
          phoneFlg = false
          console.log(phoneFlg)
          break
        case 'lg':
          phoneFlg = false
          console.log(phoneFlg)
          break
        case 'xl':
          phoneFlg = false
          console.log(phoneFlg)
          break
        default:
          phoneFlg = false
          console.log(phoneFlg)
      }
      return phoneFlg
    }
  }
}
</script>

<style scoped>
.bg{
    background-image: url("~@/assets/img/login_jtk.jpg");
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
}

</style>



// WEBPACK FOOTER //
// src/components/templates/LoginSnb.vue